// Turns the flat admin category list (each item carrying a `parentId`) into
// lookups shared by the admin category table (depth indent), the parent
// picker (breadcrumb drill + depth guard), and the product editor
// (leaf-only filter + full-path labels).
export function buildCategoryIndex(categories) {
  const byId = new Map(categories.map((c) => [c._id, c]));

  const depthOf = new Map();
  const depthFor = (id) => {
    if (depthOf.has(id)) return depthOf.get(id);
    const cat = byId.get(id);
    const d = cat && cat.parentId && byId.has(cat.parentId) ? depthFor(cat.parentId) + 1 : 0;
    depthOf.set(id, d);
    return d;
  };
  categories.forEach((c) => depthFor(c._id));

  const pathOf = new Map();
  const pathFor = (id) => {
    if (pathOf.has(id)) return pathOf.get(id);
    const cat = byId.get(id);
    if (!cat) return [];
    const parentPath = cat.parentId && byId.has(cat.parentId) ? pathFor(cat.parentId) : [];
    const path = [...parentPath, cat.name];
    pathOf.set(id, path);
    return path;
  };
  categories.forEach((c) => pathFor(c._id));

  const childrenOf = new Map();
  categories.forEach((c) => {
    const key = c.parentId || 'root';
    if (!childrenOf.has(key)) childrenOf.set(key, []);
    childrenOf.get(key).push(c);
  });

  return { byId, depthOf, pathOf, childrenOf };
}

// ids of every descendant of `rootId` (not including rootId itself), used to
// keep a category from being reparented under its own subtree.
export function descendantIds(childrenOf, rootId) {
  const result = new Set();
  const walk = (id) => {
    (childrenOf.get(id) || []).forEach((c) => {
      result.add(c._id);
      walk(c._id);
    });
  };
  walk(rootId);
  return result;
}
